import React from "react";
import { AlertCircle, CheckCircle2, Info, XCircle } from "lucide-react";
import { cn } from "@/utils/cn";

const variants = {
  default: {
    containerClass:
      "bg-gray-50 text-gray-700 dark:bg-gray-300 dark:text-gray-800",
    icon: Info,
  },
  destructive: {
    containerClass:
      "bg-red-100 text-red-900 dark:bg-red-900/10 dark:text-red-500",
    icon: XCircle,
  },
  success: {
    containerClass:
      "bg-green-100 text-green-900 dark:bg-green-900/10 dark:text-green-500",
    icon: CheckCircle2,
  },
  warning: {
    containerClass:
      "bg-yellow-100 text-yellow-900 dark:bg-yellow-900/10 dark:text-yellow-500",
    icon: AlertCircle,
  },
};

export function Alert({
  variant = "default",
  className,
  children,
  icon: CustomIcon,
  ...props
}) {
  const { containerClass, icon: DefaultIcon } =
    variants[variant] || variants.default;
  const Icon = CustomIcon || DefaultIcon;

  return (
    <div
      role="alert"
      className={cn(
        "relative w-full rounded-lg border p-4 [&>svg~*]:pl-7 [&>svg+div]:translate-y-[-3px] [&>svg]:absolute [&>svg]:left-4 [&>svg]:top-4 [&>svg]:text-current",
        containerClass,
        className
      )}
      {...props}
    >
      <Icon className="h-5 w-5" />
      <div className="flex flex-col gap-1">{children}</div>
    </div>
  );
}

export function AlertTitle({ className, children, ...props }) {
  return (
    <h5
      className={cn("mb-1 font-medium leading-none tracking-tight", className)}
      {...props}
    >
      {children}
    </h5>
  );
}

export function AlertDescription({ className, children, ...props }) {
  return (
    <div className={cn("text-sm [&_p]:leading-relaxed", className)} {...props}>
      {children}
    </div>
  );
}

export default Alert;
